import type {ImageFileConstraints} from '@/shared/application/validators/image-file.validator';
import {HEIC_INPUT_ACCEPT} from './constants';

/**
 * `accept` for a file input feeding the preprocessing helper: the destination's
 * formats plus HEIC/HEIF, which the helper converts before upload.
 */
export const imageInputAccept = (constraints: ImageFileConstraints): string =>
  [...constraints.acceptedMimeTypes, ...HEIC_INPUT_ACCEPT].join(',');
